module.exports = __webpack_public_path__ + "static/media/HK-EdUHK.fde06ec2.jpeg";